import React, { FC, useCallback } from 'react';
import { Popover, ToggleButton } from '..';
import { callOrUse } from '../../../utils/callOrUse';
import { useBoolean } from '../../../utils/hooks/useBoolean';
import styles from './ToggleButtonWithPopover.scss';
import { IOuter } from './ToggleButtonWithPopover.types';

const moveBy = { x: -7, y: 3 };
export const ToggleButtonWithPopover: FC<IOuter> = ({
  popoverContent,
  tooltipContent,
  onClick,
  className,
  selected,
  dataHook,
  ...rest
}) => {
  const { value: isMenuOpened, setFalse: closeMenu, toggle: toggleMenu } = useBoolean();

  const callOrUseNode = useCallback((node) => callOrUse(node, { closeMenu }), []);

  const handleButtonClick = useCallback(
    (event) => {
      toggleMenu();
      onClick(event, !isMenuOpened);
    },
    [onClick, isMenuOpened],
  );

  return (
    <Popover
      shown={isMenuOpened}
      showDelay={100}
      hideDelay={0}
      placement="bottom"
      onClickOutside={closeMenu}
      moveBy={moveBy}
      showArrow
      animate
      appendTo="viewport"
      zIndex={10000}
      className={className}
      dataHook={`${dataHook}-popover`}
    >
      <Popover.Element>
        <ToggleButton
          {...rest}
          selected={selected || isMenuOpened}
          labelValue={callOrUseNode(tooltipContent)}
          onClick={handleButtonClick}
          dataHook={dataHook}
        />
      </Popover.Element>
      <Popover.Content>
        <div className={styles.popoverContent}>{callOrUseNode(popoverContent)}</div>
      </Popover.Content>
    </Popover>
  );
};
